export default "__VITE_ASSET__Bekyt$bM__"